export default __webpack_public_path__ + "static/media/Amst.9889124d.png";